import React from "react";
import { Link } from "react-router-dom";

import Icon from "@components/atoms/Icon";

import { IconName } from "@const/enum";

interface IProps {
  menus: { name: string; link: string }[];
}

function Breadcrumb({ menus }: IProps) {
  return (
    <ul className="-mt-2.5 flex items-center gap-1 pc:mt-0">
      {menus.map((menu, index) => (
        <li key={`breadcrumb-${menu.name}`}>
          <div className="flex items-center gap-1">
            <Link to={menu.link}>{menu.name.replace(/\b[a-z]/g, (char) => char.toUpperCase())}</Link>
            {index < menus.length - 1 && (
              <Icon alt="RightArrow_100" className="size-4" name={IconName.RightArrow_100} />
            )}
          </div>
        </li>
      ))}
    </ul>
  );
}

export default Breadcrumb;
